import React from 'react'
import ClassNames from 'classnames'

import { SectionStyle } from './styled'

export class Section extends React.PureComponent {
  render() {
    const { className, children, error, isError } = this.props

    return (
      <SectionStyle
        {...this.props}
        // className={ClassNames('section', className)}
        className={ClassNames(
          'section',
          { 'is-error': error || isError },
          className
        )}
      >
        {children}
      </SectionStyle>
    )
  }
}

Section.defaultProps = {
  className: '',
  error: false,
  isError: false,
}
